import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import CurrentProgress from '../../common/components/current-progress'
import Container from '../../common/components/container'
import Button from '../../common/components/button'
import InputField from '../../common/components/input-field'
import QueryString from 'query-string'
import { getQueryString } from '../../common/util'
import checkedOptions from '../../common/options/check-options'
import yesNoOptions from '../../common/options/yes-no-options'
import QuoteNumber from '../../common/components/quote-number'
import { pickBy, identity } from 'lodash'

import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withFields } from '../../common/modules/fields'
import { withErrors } from '../../common/modules/errors'
import Errors from '../../common/components/errors'
import InputLabel from '../../common/components/input-label'
import FormGroup from '../../common/components/form-group'
import Alert from '../../common/components/alert'
import { withProductData } from '../../common/modules/product-data';
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'


export const formConfig = state => {
    const fields = state.fields
    const productData = state.productData;

    return {
        rules: {
            contentsSumInsured: [
                Validation.enforce.required("Please enter the sum insured between $5,000 and $250,000."),
                Validation.enforce.number("Please enter the sum insured between $5,000 and $250,000."),
                Validation.enforce.rangeInclusive(5000, 250000, "Please enter the sum insured between $5,000 and $250,000."),
            ],
            weeklyRent: [
                Validation.enforce.required("Please tell us what the weekly rent is."),
            ],
        },
        options:{},
        predicates:{
            weeklyRent: fields.holidayLet === false,
        },
        inferred:{},
        transformOut: data => data

    }

}


@withSubmission
@withFields
@withErrors
@withNavigation
@withValidation
@withProductData
@withRouteBlocker
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {
    onWeeklyRentChanged(e){

        if(e.target.value && parseInt(e.target.value)){
            if(!this.state.showRemainingForm){
                this.setState({
                    ...this.state,
                    showRemainingForm: true
                })
            }
        }

        this.props.actions.fields.updateField("weeklyRent", e.target.value ? parseInt(e.target.value) : null)
    }

    render() {
        const fields = this.props.fields;
        return ( 
            <div className="row">
                <StepTitle>Tell us about your coverage</StepTitle>	
                <QuoteNumber />	

                <InputField field="contentsSumInsured"      inline            type ="Currency"   label="How much would you like to insure your contents for?" />
                <InputField field="weeklyRent"              inline            label="What is the weekly rent amount?"    type="Currency"  help={ <p>Please put in advertised or expected weekly rent, if not currently tenanted.</p> }/>

                <StepBlock>
                    <Alert show={ fields.floodCover === 'REQUIRED' }>
                        Flood cover is included with the policy
                    </Alert>
                </StepBlock>

                <StepBlock>
                    <Alert show={ fields.floodCover === 'NOT_INCLUDED' }>
                        This policy does not include flood cover
                    </Alert>
                </StepBlock>

                <Button.Container>
                    <Button.Back route="/step-2" />
                    <Button.Continue onClick={ this.validate.bind(this) } />
                </Button.Container>
            </div>
        )

        
    }
    validate(){
        this.props.actions.validation.validate( this.submit.bind(this) );
    }
  
    submit(){
        const endpoint = this.props.submission.endpoints.step3
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            formConfig
        ] );
    }

    proceed(){
        this.props.actions.navigation.changeRoute("/step-4")
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landlords/routes/step-3.tsx